import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  &&& {
    border: none;
  }
`;

export interface BackButtonProps {
  identification: string;
  hasUnsavedChanges: (string: string) => boolean;
  resetSettings: (string: string) => void;
  onGoBack: () => void;
}

export const BackButton = observer(
  ({ identification, hasUnsavedChanges, resetSettings, onGoBack }: BackButtonProps) => {
    const [visible, setVisible] = React.useState<boolean>();
    const [t] = useTranslation('geosecma-settings');

    const onKeyDown: React.KeyboardEventHandler<any> = async (e: React.KeyboardEvent<any>) => {
      if (e.key === 'Enter' || e.key === 'Escape') {
        onClick();
        hasUnsavedChanges(identification) ? setVisible(true) : onGoBack();
        e.preventDefault();
      }
    };

    const onClick = async () => {
      hasUnsavedChanges(identification) ? setVisible(true) : onGoBack();
    };

    const onVisibleChange = (visible: boolean) => {
      !visible && setVisible(visible);
    };

    const onCancel = () => {
      setVisible(false);
    };

    const onConfirm = () => {
      resetSettings(identification);
      onGoBack();
    };

    // TODO: Add option for save and continue.

    return (
      <Popconfirm
        title={t('changesWillBeLost')}
        visible={visible}
        onVisibleChange={onVisibleChange}
        onConfirm={onConfirm}
        onCancel={onCancel}
        okText={t('ok')}
        cancelText={t('cancel')}
        placement="topRight"
      >
        <StyledButton icon={<ArrowLeftOutlined />} data-testid="goBackButton" onClick={onClick} onKeyDown={onKeyDown} />
      </Popconfirm>
    );
  }
);
